import axios from "axios";

const client = axios.create({
  baseUrl: "",
});

export const EmailServices = (body) => {
  return client.post("/api/email", body);
};
